import * as React from "react";

import { useTheme, Box, Stack, Typography, useMediaQuery } from "@mui/material";
import pipeline_fig from "../images/pipeline_report.jpg";
import financial_fig from "../images/financial.jpg";
import logistics_fig from "../images/logistics_report.jpg";
import environment_fig from "../images/environment.jpg";
import statics_fig from "../images/statistics.png";

const SectorSection = ({}) => {
  const theme = useTheme();

  const smallScreen = useMediaQuery(theme.breakpoints.down(1000));

  const sectorsItems = [
    {
      title: "Financial Market & Banking",
      description:
        "As an intern, I participated in the development of a light software which was dedicated to reconcile Excel bank's customers informations files and process payments. Beyond that internship, I worket on my behalf on the development of a financial assets markeplace ens Exchange.",
      image: financial_fig,
      techs: ["Javascript XLSX", "ElecronJS", "VanillaJS", "SQLite", "Knex"],
    },
    {
      title: "Statistics",
      description:
        "I played  key role in the development of the platform that present congolese developers statistics on behalf of the Kinshasa Digital Academy",
      image: statics_fig,
      link: "https://stateofdev.kinshasadigital.academy/",
      techs: ["GatsbyJs", "React", "XLSX JS", "Nivo Charts", "MUI"],
    },
    {
      title: "Logistics & Supply chain",
      description:
        "At SEP CONGO, with a team we worked on the developement of a light software helping stations operators to adress the market needs of fuels and helped the enterprise to avoid the supply chain break out ",
      image: logistics_fig,
      techs: [
        "NextJs",
        "React",
        "NodeJS",
        "Socket.IO",
        "Mongo Snapshot",
        "MUI",
      ],
    },
    {
      title: "Environment",
      description:
        "In Kinshasa, I have been part of the team working on the project of Benelux Africa Center, we worked together in order to provide a platform by which people could notify the organization in order to desposit their electronic wastes. These waste were inserted in the transformation cycle and this produced much benefits in the circular economy",
      image: environment_fig,
      link: "https://www.bacmd.net/",
      techs: ["StrapiJS", "BuffetJS", "Nodemailer"],
    },
    {
      title: "Pipelines",
      description:
        "We formed a two developers team when working on a complex project of SEP-CONGO, the leader of oil logistics in DRC. We developed a realtime software for simulating products into the pipelines and feeding the data produced into reports graphs and analytical tools.",
      image: pipeline_fig,
      techs: ["Socket.io", "ExpressJS", "NextJS", "XLSX", "MUI"],
    },
  ];

  return (
    <Stack
      name={"sectors"}
      sx={{
        bgcolor: theme.palette.grey[50],
        py: "8rem",
        clipPath: smallScreen
          ? "polygon(0 1%, 100% 0, 100% 99%, 0 100%)"
          : "polygon(0 3%, 100% 0, 100% 100%, 0 96%)",
      }}
    >
      <Typography
        sx={{
          fontFamily: "'Oswald', sans-serif",
          fontWeight: 700,
          fontSize: smallScreen ? "18px" : "32px",
          color: theme.palette.primary.main,
          textAlign: "center",
          px: "10vw",
          mb: smallScreen ? "2rem" : "5rem",
        }}
      >
        Sectors I worked in
      </Typography>
      <Stack
        direction={"row"}
        spacing={smallScreen ? 1.5 : 1}
        sx={{
          my: "1rem",
          mx: smallScreen ? "1.5rem" : "3rem",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {sectorsItems?.map((target, index) => {
          return (
            <a
              href={target?.link ? target?.link : "/"}
              style={{
                textDecoration: "none",
                display: "block",
                width: "100%",
                marginBottom: "1rem",
                minWidth: "250px",
              }}
            >
              <Stack
                direction={
                  smallScreen
                    ? "column"
                    : index % 2 === 0
                    ? "row"
                    : "row-reverse"
                }
                sx={{
                  minWidth: "200px",
                  overflow: "hidden",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  my: smallScreen ? "0.5rem" : "2rem",
                  flexWrap: "wrap",
                }}
              >
                <Box
                  sx={{
                    transition: "all .3s",
                    width: smallScreen ? "95%" : "50%",
                    height: "max-content",
                    [`${index % 2 === 0 ? "mr" : "ml"}`]: "2rem",
                    borderRadius: "10px",
                    overflow: "hidden",
                    "&:hover": {
                      "& img": {
                        transition: "all .3s",
                        transform: "scale(0.98)",
                      },
                    },
                  }}
                >
                  <img
                    src={target?.image}
                    alt="img"
                    style={{
                      width: "100%",
                    }}
                  />
                </Box>
                <Stack
                  sx={{
                    alignItems: "flex-start",
                    // p: "1.5rem",
                    width: smallScreen ? "95%" : "35%",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "'Oswald', sans-serif",
                      color: theme.palette.grey[700],
                      fontWeight: 600,
                      fontSize: "18px",
                      my: "1rem",
                    }}
                  >
                    {target?.title.toUpperCase()}
                  </Typography>
                  <Typography
                    sx={{
                      color: theme.palette.common.black,
                      fontSize: "12px",
                      fontWeight: theme.typography.fontWeightLight,
                    }}
                  >
                    {target?.description}
                  </Typography>
                  <Stack
                    sx={{
                      alignItems: "flex-start",
                      my: "1.7rem",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "'Oswald', sans-serif",
                        color: theme.palette.grey[800],
                      }}
                    >
                      Used technologies :
                    </Typography>
                    <Stack
                      component={"ul"}
                      direction={"row"}
                      sx={{
                        alignItems: "center",
                        mt: "1rem",
                        flexWrap: "wrap",
                      }}
                    >
                      {target?.techs.map((_target) => {
                        return (
                          <Typography
                            sx={{
                              py: "0.2rem",
                              px: "0.5rem",
                              bgcolor: theme.palette.common.white,
                              boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 8%)",
                              borderRadius: "3rem",
                              mr: "0.5rem",
                              mb: "0.5rem",
                              minWidth: "max-content",
                              fontSize: "12px",
                            }}
                          >
                            {_target}
                          </Typography>
                        );
                      })}
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>
            </a>
          );
        })}
      </Stack>
    </Stack>
  );
};

export default SectorSection;
